// extracted by mini-css-extract-plugin
module.exports = {"main":"NoAccess_main__2KRcK","borderIcon":"NoAccess_borderIcon__3E9Wy","roundCardIcon":"NoAccess_roundCardIcon__2szKy","infoText":"NoAccess_infoText__3Yi6C"};